import type { MotionProps } from 'framer-motion';

export const getSectionMediaMotionProps = ({
  isVisible,
}: {
  isVisible: boolean;
}): MotionProps => {
  return {
    animate: {
      y: isVisible ? 0 : 'var(--highlights-section-media-y-from)',
    },
    initial: {
      y: 0,
    },
    transition: {
      duration: 0.75,
      type: 'tween',
    },
  };
};
